import { ROSQuestionnaire } from '../../../../../../lib/Questionnaires'
import { CheckboxInput, TextInput } from '../../../../../shared/FormBuilder'

function Integumentary ({ disabled }) {
  return (
    <div className='row margin-top'>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.integumentaryPruritus}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.integumentaryRashes}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.integumentaryLesions}
        />
      </div>
      <div className='col-xs-12 col-sm-4 col-md-3'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.integumentaryIncisions}
        />
      </div>
      <div className='col-xs-12 margin-top'>
        <CheckboxInput
          disabled={disabled}
          {...ROSQuestionnaire.integumentaryOther}
        />
      </div>
      <div className='col-xs-12'>
        <TextInput
          disabled={disabled}
          {...ROSQuestionnaire.integumentaryOtherText}
        />
      </div>
    </div>
  )
}

export default Integumentary
